import { __assign } from "tslib";
import React from 'react';
import UserAvatarPopover from '../AvatarPopover';
import { ResourceType } from '../../types/resource';
import { BiEventType } from '@wix/da-bi/pkg/constants';
export var UserLinkPopover = function (_a) {
    var user = _a.user, className = _a.className, relatedItemBiData = _a.relatedItemBiData, biData = _a.biData, children = _a.children;
    return (React.createElement(UserAvatarPopover, { username: user.username, className: className, relatedItemBiData: relatedItemBiData, biData: __assign({ evid: BiEventType.USERNAME_HOVER_TO_OPEN, itemid: user.userId, typeid: user.type.includes('group')
                ? ResourceType.GROUP
                : ResourceType.USER }, biData) }, children));
};
UserLinkPopover.displayName = 'UserLinkPopover';
export default UserLinkPopover;
//# sourceMappingURL=UserLinkPopover.js.map